import { createAction, props } from '@ngrx/store';
import { Tracking } from '@panamax/app-state';

export const IMPORTED_ORDERS_ANALYTICS_ACTIONS = {
  trackImportedOrdersPageLoad: createAction(
    '[NgRxOrder Analytics] Track Imported Orders Page Load',
    props<{ tracking: Tracking }>(),
  ),
};
